import React, { useEffect } from 'react';
import { ScreenComponent } from 'new/routes/RouterManager';
import { ModalsProvider } from 'new/routes/ModalsContext';
import { useDrawerContext } from 'new/components/drawer/useDrawerContext';

export function configureScreenHOC(Wrapped: ScreenComponent<unknown>) {
  return (props) => {
    const modals = Wrapped?.screenConfig?.modals || [];
    const { toggleCollapse } = useDrawerContext();

    useEffect(() => {
      const drawer = Wrapped?.screenConfig?.drawer;
      if (typeof drawer?.open === 'boolean') {
        toggleCollapse(drawer?.open);
      }
    }, []);

    return (
      <ModalsProvider>
        <Wrapped {...props} />
        {modals.map((Modal, index) => (
          <Modal key={index} {...Modal.modalConfig} />
        ))}
      </ModalsProvider>
    );
  };
}
